/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {checkLinkingStatus} from '../api'

export const useMutationCheckLinkingStatus = createReactQueryMutationHook('checkLinkingStatus', checkLinkingStatus)
